module.exports = __webpack_public_path__ + "assets/img/detail-right-layer-1-c32cb4e4.png";